import { inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { DialogVideoComponent } from './dialog-video.component';

@Injectable()
export class VideoPlayerService {
  private readonly dialog = inject(MatDialog);
  private readonly sanitizer = inject(DomSanitizer);

  show(videoUrl: string, lotCode: string) {
    return this.dialog.open(DialogVideoComponent, {
      width: '600px',
      data: { videoUrl, lotCode },
    });
  }

  embed(videoUrl: string, muted = true, autoplay = true) {
    return this.generateEmbeded(videoUrl, muted, autoplay);
  }

  embedWithSound(videoUrl: string) {
    return this.generateEmbeded(videoUrl, false);
  }

  private generateEmbeded(videoUrl: string, muted = true, autoplay = true) {
    if (videoUrl == null) {
      return '';
    }

    // Detectar si es YouTube o Vimeo
    if (this.isYouTubeUrl(videoUrl)) {
      return this.generateYouTubeEmbed(videoUrl, muted, autoplay);
    } else if (this.isVimeoUrl(videoUrl)) {
      return this.generateVimeoEmbed(videoUrl, muted, autoplay);
    }

    return '';
  }

  private isYouTubeUrl(url: string): boolean {
    return url.includes('youtube.com') || url.includes('youtu.be');
  }

  private isVimeoUrl(url: string): boolean {
    return url.includes('vimeo.com');
  }

  private generateYouTubeEmbed(videoUrl: string, muted: boolean, autoplay: boolean) {
    const mutedStr = muted ? '&mute=1' : '';
    const results = videoUrl.match('[\\?&]v=([^&#]*)');
    const videoCode = results === null ? videoUrl : results[1];
    const finalVideoUrl =
      'https://www.youtube.com/embed/' +
      videoCode +
      '?autoplay=' + (autoplay ? '1' : '0') + '&loop=1' +
      mutedStr +
      '&controls=0&playsinline=1&playlist=' +
      videoCode;

    return this.sanitizer.bypassSecurityTrustResourceUrl(finalVideoUrl);
  }

  private generateVimeoEmbed(videoUrl: string, muted: boolean, autoplay: boolean) {
    // Extraer el ID del video de Vimeo
    const vimeoIdMatch = videoUrl.match(/(?:vimeo\.com\/)(\d+)/);
    if (!vimeoIdMatch) {
      return '';
    }

    const videoId = vimeoIdMatch[1];
    const mutedParam = muted ? '&muted=1' : '';
    const autoplayParam = autoplay ? '&autoplay=1' : '&autoplay=0';
    const finalVideoUrl = 
      `https://player.vimeo.com/video/${videoId}?${autoplayParam}&loop=1&autopause=0${mutedParam}&controls=0&playsinline=1&background=0&title=0&portrait=0&byline=0&responsive=1`;

    return this.sanitizer.bypassSecurityTrustResourceUrl(finalVideoUrl);
  }
}
